import styles from './banner.module.scss';

export const ImageNoMatch = () => (
  <svg
    width="100"
    height="78"
    viewBox="0 0 100 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    className={styles.image}>
    <g id="no-match">
      <g id="Flattened">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.529 0.49707C16.7028 0.49707 12.7904 4.40947 12.7904 9.23566C12.7904 11.2658 13.4846 13.1381 14.6475 14.6221C15.3872 15.566 15.7992 16.3922 15.7992 17.1574V17.4971H5.52917C2.49161 17.4971 0.0291748 19.9595 0.0291748 22.9971V54.9971C0.0291748 58.0346 2.49161 60.4971 5.52918 60.4971H18.7992V56.9645C18.7992 55.159 17.8547 53.6582 17.0088 52.5788C16.245 51.604 15.7904 50.3786 15.7904 49.0428C15.7904 45.8735 18.3597 43.3042 21.529 43.3042C24.6983 43.3042 27.2676 45.8735 27.2676 49.0428C27.2676 50.3786 26.813 51.6041 26.0491 52.5788C25.2032 53.6583 24.2587 55.1591 24.2587 56.9646V60.4971H37.5292C40.5667 60.4971 43.0292 58.0346 43.0292 54.9971V44.7271H43.232C43.9972 44.7271 44.8234 45.1391 45.7674 45.8788C47.2514 47.0418 49.1236 47.736 51.1539 47.736C55.9801 47.736 59.8925 43.8236 59.8925 38.9974C59.8925 34.1712 55.9801 30.2588 51.1539 30.2588C49.1237 30.2588 47.2514 30.953 45.7675 32.1159C44.8235 32.8556 43.9974 33.2676 43.2322 33.2676H43.0292V22.9971C43.0292 19.9595 40.5667 17.4971 37.5292 17.4971H27.2587V17.1575C27.2587 16.3923 27.6707 15.5661 28.4104 14.6222C29.5734 13.1382 30.2676 11.2659 30.2676 9.23566C30.2676 4.40947 26.3552 0.49707 21.529 0.49707ZM15.7904 9.23566C15.7904 6.06632 18.3597 3.49707 21.529 3.49707C24.6983 3.49707 27.2676 6.06632 27.2676 9.23566C27.2676 10.5715 26.813 11.7969 26.0491 12.7717C25.2032 13.8511 24.2587 15.352 24.2587 17.1575V20.4971H37.5292C38.9099 20.4971 40.0292 21.6164 40.0292 22.9971V36.2676H43.2322C45.0376 36.2676 46.5385 35.3231 47.6179 34.4772C48.5927 33.7133 49.8181 33.2588 51.1539 33.2588C54.3232 33.2588 56.8925 35.828 56.8925 38.9974C56.8925 42.1667 54.3232 44.736 51.1539 44.736C49.8181 44.736 48.5926 44.2814 47.6178 43.5175C46.5384 42.6716 45.0375 41.7271 43.232 41.7271H40.0292V54.9971C40.0292 56.3778 38.9099 57.4971 37.5292 57.4971H27.2587V56.9646C27.2587 56.1994 27.6707 55.3732 28.4104 54.4293C29.5734 52.9453 30.2676 51.073 30.2676 49.0428C30.2676 44.2166 26.3552 40.3042 21.529 40.3042C16.7028 40.3042 12.7904 44.2166 12.7904 49.0428C12.7904 51.073 13.4846 52.9452 14.6475 54.4292C15.3872 55.3731 15.7992 56.1993 15.7992 56.9645V57.4971H5.52918C4.14846 57.4971 3.02917 56.3778 3.02917 54.9971V22.9971C3.02917 21.6164 4.14846 20.4971 5.52917 20.4971H18.7992V17.1574C18.7992 15.3519 17.8547 13.8511 17.0088 12.7716C16.245 11.7969 15.7904 10.5714 15.7904 9.23566Z"
          className={styles.secondaryColor}
        />
        <path
          d="M96.8616 38.0179C96.9331 38.3794 96.9708 38.7543 96.9708 39.1395C96.9708 39.5246 96.9331 39.8995 96.8616 40.2611L99.8046 40.8433C99.9138 40.291 99.9708 39.7212 99.9708 39.1395C99.9708 38.5578 99.9138 37.9879 99.8046 37.4357L96.8616 38.0179Z"
          className={styles.secondaryColor}
        />
        <path
          d="M96.0052 42.3269C95.5858 42.9533 95.0461 43.493 94.4196 43.9124L96.0886 46.4053C97.0409 45.7677 97.8605 44.9481 98.4981 43.9958L96.0052 42.3269Z"
          className={styles.secondaryColor}
        />
        <path
          d="M94.4196 34.3666C95.0461 34.786 95.5858 35.3256 96.0052 35.9521L98.4981 34.2831C97.8605 33.3308 97.0409 32.5112 96.0886 31.8737L94.4196 34.3666Z"
          className={styles.secondaryColor}
        />
        <path
          d="M91.2323 33.4009C91.6174 33.4009 91.9923 33.4386 92.3539 33.5101L92.9361 30.5672C92.3838 30.4579 91.8139 30.4009 91.2323 30.4009C90.7419 30.4009 90.2599 30.4414 89.7897 30.5196L90.2819 33.479C90.5901 33.4277 90.9075 33.4009 91.2323 33.4009Z"
          className={styles.secondaryColor}
        />
        <path
          d="M92.3539 44.7688C91.9923 44.8403 91.6174 44.8781 91.2323 44.8781C90.9075 44.8781 90.5901 44.8512 90.2819 44.8L89.7896 47.7593C90.2599 47.8375 90.7419 47.8781 91.2323 47.8781C91.8139 47.8781 92.3838 47.821 92.9361 47.7118L92.3539 44.7688Z"
          className={styles.secondaryColor}
        />
        <path
          d="M87.6963 34.6193C87.9459 34.4237 88.2118 34.2485 88.4916 34.0961L87.0563 31.4617C86.6298 31.6941 86.2251 31.9608 85.8458 32.258C85.6229 32.4327 85.4008 32.594 85.1786 32.7376L86.8079 35.2567C87.1223 35.0534 87.419 34.8366 87.6963 34.6193Z"
          className={styles.secondaryColor}
        />
        <path
          d="M88.4916 44.1829C88.2118 44.0304 87.9458 43.8552 87.6962 43.6596C87.4189 43.4423 87.1222 43.2255 86.8078 43.0222L85.1785 45.5412C85.4007 45.6849 85.6228 45.8461 85.8457 46.0209C86.225 46.3181 86.6297 46.5848 87.0562 46.8172L88.4916 44.1829Z"
          className={styles.secondaryColor}
        />
        <path
          d="M83.3106 36.4097C83.7686 36.4097 84.2072 36.3486 84.6228 36.2446L83.8941 33.3344C83.6939 33.3846 83.5003 33.4097 83.3106 33.4097H82.8506V33.4384H79.9708V34.9097C79.9708 35.7381 80.6424 36.4097 81.4708 36.4097H83.3106Z"
          className={styles.secondaryColor}
        />
        <path
          d="M84.6227 42.0342C84.2071 41.9302 83.7684 41.8691 83.3104 41.8691H81.4708C80.6424 41.8691 79.9708 42.5407 79.9708 43.3691V44.8405H82.8505V44.8691H83.3104C83.5002 44.8691 83.6937 44.8942 83.894 44.9444L84.6227 42.0342Z"
          className={styles.secondaryColor}
        />
        <path
          d="M79.7817 22.1831C79.9031 22.4758 79.9708 22.7979 79.9708 23.1397V24.6109H82.9708V23.1397C82.9708 22.3967 82.8227 21.6845 82.5529 21.0339L79.7817 22.1831Z"
          className={styles.secondaryColor}
        />
        <path
          d="M82.5529 57.2454C82.8227 56.5948 82.9708 55.8826 82.9708 55.1396V53.6683H79.9708V55.1396C79.9708 55.4814 79.9031 55.8035 79.7817 56.0962L82.5529 57.2454Z"
          className={styles.secondaryColor}
        />
        <path
          d="M77.4708 20.6397C77.8126 20.6397 78.1347 20.7074 78.4274 20.8288L79.5766 18.0576C78.926 17.7878 78.2138 17.6397 77.4708 17.6397H75.8708V20.6397H77.4708Z"
          className={styles.secondaryColor}
        />
        <path
          d="M78.4274 57.4505C78.1347 57.5719 77.8126 57.6396 77.4708 57.6396H75.9995V60.6396H77.4708C78.2138 60.6396 78.926 60.4915 79.5766 60.2217L78.4274 57.4505Z"
          className={styles.secondaryColor}
        />
        <path
          d="M69.4708 20.6396L72.6709 20.6397V17.6397H69.4708V20.6396Z"
          className={styles.secondaryColor}
        />
        <path
          d="M67.131 67.814C67.1823 68.1222 67.2091 68.4396 67.2091 68.7643C67.2091 69.1495 67.1714 69.5244 67.0999 69.8859L70.0428 70.4681C70.1521 69.9159 70.2091 69.346 70.2091 68.7643C70.2091 68.274 70.1686 67.792 70.0904 67.3218L67.131 67.814Z"
          className={styles.secondaryColor}
        />
        <path
          d="M65.9907 65.2284C66.1863 65.478 66.3615 65.7439 66.514 66.0237L69.1483 64.5883C68.9159 64.1619 68.6493 63.7572 68.352 63.3779C68.1773 63.155 68.016 62.9328 67.8724 62.7107L65.3533 64.34C65.5566 64.6544 65.7734 64.9511 65.9907 65.2284Z"
          className={styles.secondaryColor}
        />
        <path
          d="M66.2434 71.9517C65.824 72.5782 65.2844 73.1179 64.6579 73.5372L66.3269 76.0302C67.2792 75.3926 68.0988 74.573 68.7364 73.6207L66.2434 71.9517Z"
          className={styles.secondaryColor}
        />
        <path
          d="M64.2003 60.8426C64.2003 61.3006 64.2614 61.7393 64.3654 62.1549L67.2756 61.4262C67.2254 61.226 67.2003 61.0324 67.2003 60.8426V60.4169H67.1716L67.2003 59.5654V59.1396H67.1716V57.6396H65.7003C64.8719 57.6396 64.2003 58.3112 64.2003 59.1396V60.8426Z"
          className={styles.secondaryColor}
        />
        <path
          d="M62.5921 74.3937C62.2306 74.4652 61.8557 74.5029 61.4705 74.5029C61.0854 74.5029 60.7105 74.4652 60.3489 74.3937L59.7667 77.3366C60.319 77.4459 60.8888 77.5029 61.4705 77.5029C62.0522 77.5029 62.6221 77.4459 63.1743 77.3366L62.5921 74.3937Z"
          className={styles.secondaryColor}
        />
        <path
          d="M58.7409 59.1396C58.7409 58.3112 58.0693 57.6396 57.2409 57.6396H55.7696V59.1396L55.7409 60.4168V60.8425C55.7409 61.0322 55.7158 61.2258 55.6656 61.4261L58.5758 62.1548C58.6798 61.7392 58.7409 61.3005 58.7409 60.8425V59.1396Z"
          className={styles.secondaryColor}
        />
        <path
          d="M58.2831 73.5372C57.6567 73.1178 57.117 72.5782 56.6976 71.9517L54.2047 73.6207C54.8423 74.573 55.6619 75.3926 56.6142 76.0302L58.2831 73.5372Z"
          className={styles.secondaryColor}
        />
        <path
          d="M56.9504 65.2283C57.1677 64.951 57.3845 64.6543 57.5878 64.3399L55.0688 62.7106C54.9251 62.9327 54.7639 63.1549 54.5891 63.3778C54.2919 63.7571 54.0252 64.1618 53.7928 64.5883L56.4272 66.0237C56.5796 65.7439 56.7548 65.4779 56.9504 65.2283Z"
          className={styles.secondaryColor}
        />
        <path
          d="M55.8412 69.8859C55.7697 69.5244 55.732 69.1495 55.732 68.7643C55.732 68.4396 55.7588 68.1222 55.81 67.814L52.8507 67.3217C52.7725 67.792 52.732 68.274 52.732 68.7643C52.732 69.346 52.789 69.9159 52.8983 70.4681L55.8412 69.8859Z"
          className={styles.secondaryColor}
        />
        <path
          d="M44.5143 20.8288C44.807 20.7074 45.1291 20.6396 45.4708 20.6396H47.0708V17.6396H45.4708C44.7279 17.6396 44.0157 17.7878 43.3651 18.0576L44.5143 20.8288Z"
          className={styles.secondaryColor}
        />
        <path
          d="M45.4708 57.6396C45.1291 57.6396 44.807 57.5719 44.5143 57.4505L43.3651 60.2217C44.0157 60.4915 44.7279 60.6396 45.4708 60.6396H46.9421V57.6396H45.4708Z"
          className={styles.secondaryColor}
        />
        <path
          d="M79.9708 27.5534V30.4959H82.9708V27.5534H79.9708Z"
          className={styles.secondaryColor}
        />
        <path
          d="M79.9708 47.7831V50.7257H82.9708V47.7831H79.9708Z"
          className={styles.secondaryColor}
        />
        <path
          d="M73.0569 57.6396H70.1143V60.6396H73.0569V57.6396Z"
          className={styles.secondaryColor}
        />
        <path
          d="M63.0708 20.6396H66.2709V17.6396H63.0708V20.6396Z"
          className={styles.secondaryColor}
        />
        <path
          d="M56.6708 20.6396H59.8708V17.6396H56.6708V20.6396Z"
          className={styles.secondaryColor}
        />
        <path
          d="M50.2708 20.6396H53.4708V17.6396H50.2708V20.6396Z"
          className={styles.secondaryColor}
        />
        <path
          d="M52.8271 57.6396H49.8846V60.6396H52.8271V57.6396Z"
          className={styles.secondaryColor}
        />
      </g>
    </g>
  </svg>
);
